'use client';

import FadeIn from '../ui/FadeIn';
import { Star } from 'lucide-react';
import { useTranslations } from '@/lib/i18n/TranslationProvider';

export default function TrustSignals() {
    const { t } = useTranslations();
    return (
        <section className="section-padding-tight border-t border-[var(--color-md-outline)] bg-[var(--color-md-surface)]">
            <div className="container mx-auto px-6">
                <FadeIn className="flex flex-col items-center justify-center text-center gap-8">
                    <div className="flex flex-wrap justify-center gap-10 md:gap-20 items-center opacity-80 hover:opacity-100 transition-opacity">
                        <a
                            href="https://chromewebstore.google.com/detail/wa-contacts-extractor-wav/dembjmabcapfkbnbbcphbfcjoghlkcoi"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-3 group"
                            onClick={() => {
                                if (typeof window !== 'undefined' && (window as any).gtag) {
                                    (window as any).gtag('event', 'conversion', {
                                        'send_to': 'AW-17987992395/H28vCO_Sk4QcEMv2q4FD',
                                        'value': 1.0,
                                        'currency': 'INR'
                                    });
                                }
                            }}
                        >
                            <div className="flex -space-x-1">
                                {[1, 2, 3, 4, 5].map(i => (
                                    <Star key={i} className="w-5 h-5 text-[var(--color-md-tertiary)] fill-current" />
                                ))}
                            </div>
                            <div className="text-left">
                                <div className="text-xs font-bold text-[var(--color-md-on-surface)] group-hover:underline decoration-[var(--color-md-primary)]">{t.trustSignals.chromeWebStore}</div>
                                <div className="text-[10px] text-[var(--color-md-on-surface-variant)]">{t.trustSignals.rated}</div>
                            </div>
                        </a>

                        <div className="h-8 w-px bg-[var(--color-md-outline)] hidden sm:block" />

                        <div className="text-center">
                            <div className="text-lg font-black text-[var(--color-md-primary)]">WebAssembly</div>
                            <div className="text-xs font-semibold text-[var(--color-md-on-surface-variant)]">{t.trustSignals.webAssembly}</div>
                        </div>

                        <div className="h-8 w-px bg-[var(--color-md-outline)] hidden sm:block" />

                        <div className="text-center">
                            <div className="text-lg font-black text-[var(--color-md-primary)]">AES-256</div>
                            <div className="text-xs font-semibold text-[var(--color-md-on-surface-variant)]">{t.trustSignals.aes}</div>
                        </div>
                    </div>

                    <div className="mt-8 pt-8 border-t border-[var(--color-md-outline)] w-full max-w-md">
                        <p className="text-[11px] text-[var(--color-md-on-surface-variant)]">
                            {t.trustSignals.disclaimer}
                        </p>
                    </div>
                </FadeIn>
            </div>
        </section>
    );
}
